import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { PropertyGroup } from './models/template.model';

@Injectable()
export class PropertyGroupService {
  private readonly _onUpdatePropertyGroups = signal<PropertyGroup[]>([]);
  readonly onUpdatePropertyGroups$ = toObservable(this._onUpdatePropertyGroups);

  groupName = 1;

  setReportPropertyGroups(propertyGroups: PropertyGroup[]) {
    this._onUpdatePropertyGroups.set(propertyGroups);
  }

  getReportPropertyGroupsStream(): Observable<PropertyGroup[]> {
    return this.onUpdatePropertyGroups$;
  }

  getReportPropertyGroups(): PropertyGroup[] {
    return this._onUpdatePropertyGroups();
  }
}
